import { Component, Input, OnInit } from '@angular/core';
import { NavController, NavParams, Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { DailySlotService } from 'src/app/services/daily-slot/daily-slot.service';
import { EventsService } from 'src/app/services/event/event.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { MobileDataService } from 'src/app/services/mobile-data/mobile-data.service';
import { DailySpinService } from 'src/app/services/daily-spin/daily-spin.service';
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

@Component({
  selector: 'app-daily-slot',
  templateUrl: './daily-slot.component.html',
  styleUrls: ['./daily-slot.component.scss'],
})

export class DailySlotComponent implements OnInit {
  @Input() navigateBackPage: string;
  @Input() availableSpins: number;

  public slotUrl;
  private subscriber1: any;
  private subscriber2: any;
  private subscriber3: any;
  protected intervalID: any;
  protected titlelabel: string = "";
  protected mobileLandscape: boolean =  false;

  constructor(
    public navCtrl: NavController,
    private dailySlotService: DailySlotService,
    public events: EventsService,
    private gameHubControllerService: GameHubControllerService,
    public appLinks: AppLinksService,
    private navigator: Navigator,
    private config: ConfigService,
    private mobileData: MobileDataService,
    private webcontentService: WebcontentService,
    private lobbyNavigator: LobbyNavigator,
    public platform: Platform,
    private screenOrientation: ScreenOrientation,
    private dailySpinService: DailySpinService,
  ) {
  }

  ionViewWillEnter() {
    this.subscriber1 = fromEvent(window, 'resize').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.updateCSS();
      });

    this.subscriber2 = fromEvent(window, 'scroll').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.updateCSS();
      });

    this.subscriber3 = fromEvent(window, 'message').pipe(
      debounceTime(100))
      .subscribe((event) => {
        this.oniFrameMessage(event);
      });

  }

  async ngOnInit() {
    if(this.platform.is("mobile")){
      this.mobileLandscape = this.platform.isLandscape();
      this.screenOrientation.onChange().subscribe(
          () => {
            this.mobileLandscape = ! this.mobileLandscape;
          }
      ); 
    }

    this.slotUrl = this.dailySpinService.getDailySpinGameUrl();
    if(!this.slotUrl || this.slotUrl==""){
      let data = await Promise.resolve(this.dailySpinService.initDailySpinGameUrl());
      if(!!data && data.result == 1){
        return this.gameHubControllerService.launchDailySpin(this.availableSpins);
      } else{
        this.ionViewDidLeave();
        this.navigator.toLobby();
      }
    }
    this.events.publish("event:freespin:loading:end", {});

    this.events.subscribe('event:dailyspin:close', () => {
      this.navigator.dismiss();
    });
    this.events.subscribe('event:dailyspin.spinnow', (data) => {
      this.slotUrl = data.slotUrl;
    });
  }

  ionViewDidEnter() {
    this.events.publish("event:balanceState", { show: false, code: "IN_GAME" });

    this.updateCSS();
  }

  ionViewDidLeave() {
    this.subscriber1.unsubscribe();
    this.subscriber2.unsubscribe();
    this.subscriber3.unsubscribe();
    this.events.unsubscribe('event:dailyspin:close');
    this.events.unsubscribe('event:dailyspin.spinnow');
    this.events.publish("event:balanceState", { show: true });
    this.events.publish("event:appInit:next");
    this.lobbyNavigator.selectHome();
  }

  oniFrameMessage(event) {
    if (!!(event.data)) {
      switch (event.data) {
        case "close_game":
          this.navigator.dismiss();
          this.events.publish("event:freespin:loading:end", {});
          this.lobbyNavigator.selectHome();
          break;
        case "show_terms_ios":
          let updateURL = event.data.termsURL
          this.appLinks.openExternalPage(updateURL);
          break;
        case "show_rules":
          let rulesURL = this.config.getConfig().FEATURE_DAILYSLOT_RULES;
          this.appLinks.popupToDialog(rulesURL);
          break;
      }
    }
  }

  updateCSS() {

    let modal = document.querySelectorAll('.custom-modal-class')[0];

    if (!!modal) {
      let top = window.scrollY > 0 ? window.scrollY : 0;
      let style = `
            width: ${window.innerWidth}px !important;
            height: ${window.innerHeight}px !important;
            left: 0px !important;
            top: 0px !important;
            margin-top: ${top}px !important;
            background: rgba(0, 0, 0, 0.3);
            opacity:1;
            --background: transparent;
            --width: ${window.innerWidth}px !important;
            --height: ${window.innerHeight}px !important;
        `;

      modal.setAttribute("style", style);
    }

    try {
      let modalwrapper: any = document.querySelectorAll('ion-modal')[0].shadowRoot.children[1];

      if (modalwrapper != null) {
        let style = `
                box-shadow: none !important;
            `;

        modalwrapper.setAttribute("style", style);
      }
    }
    catch {
      console.log("daily-slot: unable to locate shadowRoot.children[1]")
    }
  }

  onBack = () => {
    if (!!this.navigateBackPage) {
      if (this.navigateBackPage == "default") {
        this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
      } else if(this.navigateBackPage == "navbar" || this.navigateBackPage == "navbar-text") {
        return this.navigator.toLobby();
      } else {
        this.navigator.navigateTo(this.navigateBackPage);
      }
    } else {
      this.navigator.toLobby();
    }
  };
}
